import { getSchoolStages, getStages, getUserCoursesBooks } from "@/utils/apis";
import Cookie from "js-cookie";
import moment from "moment";
import qs from "qs";
import solarlunar from "solarlunar";
const pageIndex = 1;
const userSettingStageId = "userSettingStageId";
const userSettingSubjectId = "userSettingSubjectId";
const userSettingTextBookId = "userSettingTextBookId";
// 使用范围
const USESCOPE = "USESCOPE";
const CURRENTCOURSE = "CURRENTCOURSE";
function handleFirstUseScope() {
  // debugger;
  let useScope = Cookie.get(USESCOPE);
  if (useScope) {
    let useScopeArr = useScope.split("|");
    let [year, term, grade] = useScopeArr;

    return {
      year,
      term,
      grade,
    };
  } else {
    return {
      year: "",
      term: "",
      grade: "",
    };
  }
}
let util = {
  xepHref(href) {
    const current = window.location.href;
    if (href.includes("xep_flag")) {
      return href;
    } else if (current.includes("xep_flag")) {
      const url = new URL(href);
      url.searchParams.append("xep_flag", "1");
      return url.href;
    }
    return href;
  },
  timestampToTime(timestamp, joinStr = "/") {
    var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    // console.log("date", date);
    let s = date.getSeconds();
    let m = date.getMinutes();
    let h = date.getHours();
    var Y = date.getFullYear() + joinStr;
    var M =
      (date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) + joinStr;
    var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
    h = (h < 10 ? "0" + h : h) + ":";
    m = (m < 10 ? "0" + m : m) + ":";
    s = s < 10 ? "0" + s : s;
    return Y + M + D + h + m + s;
  },
  getBacColor(color) {
    if (color && color[0] === "#") {
      let r = 0,
        g = 0,
        b = 0;
      if (color.length === 7) {
        r = parseInt(color.slice(1, 3), 16);
        g = parseInt(color.slice(3, 5), 16);
        b = parseInt(color.slice(5, 7), 16);
      } else if (color.length === 4) {
        r =
          parseInt(color.slice(1, 2), 16) * 16 +
          parseInt(color.slice(1, 2), 16);
        g =
          parseInt(color.slice(2, 3), 16) * 16 +
          parseInt(color.slice(2, 3), 16);
        b =
          parseInt(color.slice(3, 4), 16) * 16 +
          parseInt(color.slice(3, 4), 16);
      }
      return `rgba(${r}, ${g}, ${b},0.1)`;
    }
  },
  /**
   * 返回一个节流函数，每隔一定时间执行一次，比如滚动时，不会多次触发同一个函数，这样可以优化体验
   * @param {*} func
   * @param {*} wait
   * @param {*} options
   */
  throttle(func, wait, options) {
    /* options的默认值
     *  表示首次调用返回值方法时，会马上调用func；否则仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用func。
     *  options.leading = true;
     * 表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用func函数，若后续在既未达到wait指定的时间间隔和func函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
     *  options.trailing = true;
     * 注意：当options.trailing = false时，效果与上面的简单实现效果相同
     */
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function () {
      previous = options.leading === false ? 0 : Date.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function () {
      var now = Date.now();
      if (!previous && options.leading === false) previous = now;
      // 计算剩余时间
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      // 当到达wait指定的时间间隔，则调用func函数
      // 精彩之处：按理来说remaining <= 0已经足够证明已经到达wait的时间间隔，但这里还考虑到假如客户端修改了系统时间则马上执行func函数。
      if (remaining <= 0 || remaining > wait) {
        // 由于setTimeout存在最小时间精度问题，因此会存在到达wait的时间间隔，但之前设置的setTimeout操作还没被执行，因此为保险起见，这里先清理setTimeout操作
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        // options.trailing=true时，延时执行func函数
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  },
  /**
   * 返回一个去抖函数，在多次触发的时候，只执行一次
   * @param {*} func 待执行的function
   * @param {*} delay 超过delay的时间才执行，否则重新计时
   */
  debounce(func, delay) {
    let timer;
    return function debouncedFunc() {
      var context = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        func.apply(context, args);
      }, delay);
    };
  },
  queryToTechByTextbook(textbook) {
    return {
      textbookId: textbook.bookId,
      stageId: textbook.stageId,
      subjectId: textbook.subjectId,
      pageIndex: pageIndex,
      pageSize: this.pageSize,
    };
  },
  queryToPageByCourse(course) {
    if (course) {
      return {
        courseId: course.courseId,
        stageId: course.stageId,
        subjectId: course.subjectId,
        pageIndex: pageIndex,
        pageSize: this.pageSize,
      };
    } else {
      return {
        pageIndex: pageIndex,
        pageSize: this.pageSize,
      };
    }
  },
  async queryToSchoolBased(isMySchoolBase = false) {
    let data = await getUserCoursesBooks();
    let { result: stages } = await getSchoolStages(true);
    let courses = data.result;
    let course = null;
    let currentBook = null;
    // let versionId = null;
    let userStageId = Number(Cookie.get(userSettingStageId)) || 0;
    let userSubjectId = Number(Cookie.get(userSettingSubjectId)) || 0;
    let userTextBookId = Number(Cookie.get(userSettingTextBookId)) || 0;
    let params = {};
    if (userStageId && userSubjectId) {
      courses.forEach((item) => {
        if (item.stageId == userStageId && item.subjectId == userSubjectId) {
          course = item;
          item.bookList.forEach((book) => {
            if (userTextBookId && book.bookId == userTextBookId) {
              currentBook = book;
              // versionId = book.versionId;
            }
          });
          if (!userTextBookId) {
            currentBook = course.bookList[0];
            // versionId = currentBook && course.bookList[0].versionId;
          }

          return;
        }
      });
      // 如果course不存在说明就是之前切换课程但是没有选择教材下次在进入到校本资源页面中找不到对应保存的教材 或者说是上次切换了课程因为现在不需要保存
      if (!course) {
        stages.forEach((item) => {
          if (item.id == userStageId) {
            item.subjectList.forEach((subject) => {
              subject.course.subjectId = subject.id;
              subject.course.stageName = item.name;
              subject.course.stageId = item.id;
              subject.course.subjectName = subject.name;
              if (subject.id == userSubjectId) {
                course = subject.course;
                currentBook = null;
              }
            });
          }
        });
      }
    } else {
      course = courses[0];
      let firstBook = course.bookList[0];
      currentBook =
        firstBook && firstBook.versionName == "不限"
          ? course.bookList[1]
          : firstBook;

      // versionId = currentBook ? currentBook.versionId : 0;
    }
    // console.log("courses", course);
    !isMySchoolBase ? (params.courseId = course.courseId) : null;
    !isMySchoolBase ? (params.stageId = course.stageId) : null;
    !isMySchoolBase ? (params.subjectId = course.subjectId) : null;
    params.pageIndex = pageIndex;
    // console.log("pageSize1", this.pageSize);
    params.pageSize = this.pageSize;
    if (currentBook) {
      // params.textbookId = currentBook.bookId;
      // params.versionId = versionId;
    } else if (!currentBook && userTextBookId) {
      // params.textbookId = userTextBookId;
    }
    let { year, term, grade } = handleFirstUseScope();
    // console.log("grade", grade);
    year ? (params.schoolYear = year) : null;
    term ? (params.term = term) : null;
    grade ? (params.gradeIds = grade) : null;
    // console.log('params',params)
    return params;
  },
  mediaQuery() {
    const windowWidth = window.innerWidth;
    let count = 8;
    if (windowWidth >= 2001) {
      count = 8;
    } else if (windowWidth > 1800 && windowWidth <= 2000) {
      count = 8;
    } else if (windowWidth > 1400 && windowWidth <= 1799) {
      count = 6;
    } else if (windowWidth > 1080 && windowWidth <= 1399) {
      count = 4;
    }
    return count;
  },
  // 获取cookie 是否模糊匹配
  getCookie(name, isDim = false) {
    const arr = document.cookie.match(
      new RegExp(
        "(^| )" + name + (isDim ? "[^;=]*" : "") + "=([^;]*)(;|$)",
        isDim ? "g" : ""
      )
    );
    return !arr ? null : isDim ? arr : decodeURIComponent(arr[2]);
  },
  setCookie(name, value, Hours = 1) {
    const exp = new Date();
    exp.setTime(exp.getTime() + Hours * 60 * 60 * 1000);
    document.cookie =
      name + "=" + escape(value) + ";expires=" + exp.toGMTString();
  },
  // 分页条数的列表
  pageSizes: [20, 30, 50],
  // 每页默认显示的条数
  // pageSize: 30,
  pageSize: 30,
  // 资料类型
  softTypes: [
    {
      id: 1,
      name: "资料",
    },
    {
      id: 2,
      name: "专辑",
    },
    // {
    //   id: 3,
    //   name: "套卷",
    // }
  ],
  stagesMap: {
    2: "xx",
    3: "cz",
    4: "gz",
    6: "zz",
  },
  // 学段id对应的简称
  // 解析url
  parseUrl(url) {
    if (!url.length) return;
    const route = {
      query: {},
    };
    const arr = url.split("?");
    route.path = arr[0];
    if (arr.length >= 2) {
      const queryArr = arr[1].split("&");
      queryArr.length &&
        queryArr.forEach((query) => {
          const itemArr = query.split("=");
          route.query[itemArr[0]] = itemArr[1];
        });
    }
    return route;
  },
  isIE() {
    //ie?
    return !!window.ActiveXObject || "ActiveXObject" in window;
  },
  addSoftId(softId) {
    // let softId = Math.random();
    let { pathname, search } = location;
    //去掉问号
    if (search.startsWith("?")) {
      search = search.substring(1, search.length);
    }
    let query = qs.parse(search);
    query.softId = softId;
    search = qs.stringify(query);
    history.replaceState(null, null, `${pathname}?${search}`);
  },
  deleteSoftId() {
    let { pathname, search } = location;
    //去掉问号
    if (search.startsWith("?")) {
      search = search.substring(1, search.length);
    }
    let query = qs.parse(search);
    delete query.softId;
    search = qs.stringify(query);
    search = search && `?${search}`;
    history.replaceState(null, null, `${pathname}${search}`);
  },
  /**
   * 生成min-max之间的随机数，包含min和max
   */
  getRandom(min, max) {
    if (min === undefined || max === undefined) {
      throw new Error("getRandom need two params");
    }
    return Math.round(Math.random() * (max - min) + min);
  },
  async getUserCourses(store, userInfo) {
    const data = await getUserCoursesBooks();
    if (data.code === 200 && data.result.length) {
      // 存储用户的教材到vuex的bookList
      store.commit("setCourses", data.result);
      return await this.getCurrentCourse(data.result || [], userInfo, store);
    } else {
      return await this.getCurrentCourse(data.result || [], userInfo, store);
    }
  },
  async getCurrentCourse(courses, userInfo, store) {
    // console.log("courses, userInfo, store", courses, userInfo, store);
    let currentCourse = null;
    if (!courses.length) {
      let { result: stages } = await getStages();
      if (stages.length > 0) {
        currentCourse = stages[0].subjectList[0].course;
      }
    } else {
      currentCourse =
        localStorage.getItem(`${userInfo.userId}-` + CURRENTCOURSE) || null;
      if (currentCourse && currentCourse != "undefined") {
        // 判断cookie中的当前课程与接口中的课程是否一致
        //  这块处理时为了当像同步页面的时候切换教材保存到所在课程中的时候，需要重新获取用户课程并且重新存储当前的课程 这 时候需要判断当前的cookie是否与最新的一致如果不一致需要更新cookie值
        currentCourse = JSON.parse(currentCourse);
        let newCurrentCourse = courses.find((item) => {
          return (
            item.stageId === currentCourse.stageId &&
            item.subjectId === currentCourse.subjectId
          );
        });
        if (newCurrentCourse) {
          currentCourse =
            JSON.stringify(newCurrentCourse) == JSON.stringify(currentCourse)
              ? currentCourse
              : newCurrentCourse;
        } else {
          // 判断如果cookie中存在但是在用户课程列表中不存在 那么默认显示第一个课程
          currentCourse = courses[0];
        }
      } else {
        currentCourse = courses[0];
      }
      localStorage.setItem(
        `${userInfo.userId}-` + CURRENTCOURSE,
        JSON.stringify(currentCourse)
      );
    }
    store.commit("setCurrentCourse", currentCourse);
    return currentCourse;
  },
  // 将数组进行拍平处理
  treeToList(tree, childrenParam) {
    var queen = [];
    var out = [];
    queen = queen.concat(tree);
    while (queen.length) {
      var first = queen.shift();
      if (first[childrenParam]) {
        queen = queen.concat(first[childrenParam]);
        // delete first[childrenParam];
      }
      out.push(first);
    }
    return out;
  },
  judgeInIframe() {
    const params = new URLSearchParams(window.location.search);
    const value = params.get("xep_flag");
    return window.self != window.top || Boolean(value);
  },
  getIframeUrl() {
    if (window.frames && window.frames.location.href) {
      let xep_url = window.frames.location.href;
      // console.log("xep_url", xep_url);
      let reg = /xep_url=([^&]*)/gi;
      // xep_url.test(reg);
      let result = xep_url.match(reg);
      result = result[0].split("=");
      // console.log("result", decodeURIComponent(result[1]));
      return decodeURIComponent(result[1]);
    }
  },
  getIframeCourseId() {
    // console.log("window.self.frameElement",window.frames.location.href)
    if (window.frames && window.frames.location.href) {
      let xep_url = window.frames.location.href;
      let reg = /courseId=(\d*)/gi;
      let result = xep_url.match(reg);
      result = result[0].split("=");
      // console.log('result-----',result)
      return decodeURIComponent(result[1]);
      // console.log('result----',result[0])
    }
  },
  getParentUrl() {
    var url = null;
    if (parent !== window) {
      try {
        url = parent.location.href;
      } catch (e) {
        url = document.referrer;
      }
    }
    return url;
  },
  getWeekDates() {
    const today = moment();
    const startOfWeek = today.clone().startOf("isoWeek"); // ISO周从周一开始
    const weekData = [];

    for (let i = 0; i < 7; i++) {
      const currentDay = startOfWeek.clone().add(i, "days");
      // 获取阴历和节气信息
      const lunarInfo = solarlunar.solar2lunar(
        currentDay.year(),
        currentDay.month() + 1, // JavaScript的月份是从0开始
        currentDay.date()
      );
      // console.log("lunarInfo", lunarInfo);
      weekData.push({
        gregorian: currentDay.format("MM-DD"),
        lunarDate: `${lunarInfo.dayCn}`, // 阴历日期
        ncWeek: lunarInfo.ncWeek.replace("星期", "周"),
        solarTerm: lunarInfo.term, // 节气
      });
    }
    return weekData;
  },
  hideMenu(vm) {
    console.log("点击2");
    const that = this;
    document.addEventListener("click", function (event) {
      const target = event.target;
      const tabItem = document.querySelector(".tab-item");
      const catalog = document.querySelector(".catalog");
      const switchBox = document.querySelector(".switch-wrapper");
      const mTabs = document.querySelector(".m-tabs");
      const mFilters = document.querySelector(".m-filters");
      const currentTitle = document.querySelector(".current-title");
      const mbody = document.querySelector(".mbody");
      const tanChuangBox = document.querySelectorAll(".tan-chuang");
      const kpointCatalog = document.querySelector(".kpoint-catalog");
      const resourceCategories = document.querySelector(".resource-categories");
      const tabs = document.querySelector(".tabs");
      const menuBox = document.querySelector(".menu-box");
      const sciHeaderLeft = document.querySelector(".sci-header-left");
      const sciList = document.querySelector(".sci-list");
      const setting = document.querySelector(".setting-1");
      const introlBtn = document.querySelector(".introl-btn");
      // 获取所有的 dialog wrapper
      const dialogWrappers = document.querySelectorAll(".el-dialog__wrapper");
      // 检查点击的元素是否在任何一个 feedback dialog 内
      const isInFeedbackDialog = Array.from(dialogWrappers).some((wrapper) => {
        // 检查当前 wrapper 是否包含 feedback 类的直接子元素
        const feedbackDialog = wrapper.querySelector(".el-dialog.feedback");
        const feedbackImgPreviewDialog = wrapper.querySelector(
          ".el-dialog.feedback-img-preview"
        );
        return (
          (feedbackDialog || feedbackImgPreviewDialog) &&
          (target === wrapper || wrapper.contains(target))
        );
      });
      // 检查点击的元素是否在任何一个 tan chuang dialog 内
      const isInTanChuang = Array.from(tanChuangBox).some((wrapper) => {
        return wrapper && (target === wrapper || wrapper.contains(target));
      });
      const isInDownloadErrorDialog = Array.from(dialogWrappers).some(
        (wrapper) => {
          // 检查当前 wrapper 是否包含 download-error-dialog 类的直接子元素
          const downloadErrorDialog = wrapper.querySelector(
            ".el-dialog.download-error-dialog"
          );
          return (
            downloadErrorDialog &&
            (target === wrapper || wrapper.contains(target))
          );
        }
      );
      // (target === tanChuangBox || tanChuangBox.contains(target))))
      if (
        (switchBox && (target === switchBox || switchBox.contains(target))) ||
        (tabItem && (target === tabItem || tabItem.contains(target))) ||
        (catalog && (target === catalog || catalog.contains(target))) ||
        (mTabs && (target === mTabs || mTabs.contains(target))) ||
        (mFilters && (target === mFilters || mFilters.contains(target))) ||
        (currentTitle &&
          (target === currentTitle || currentTitle.contains(target))) ||
        (mbody && (target === mbody || mbody.contains(target))) ||
        isInTanChuang ||
        (kpointCatalog &&
          (target === kpointCatalog || kpointCatalog.contains(target))) ||
        (resourceCategories &&
          (target === resourceCategories ||
            resourceCategories.contains(target))) ||
        (tabs && (target === tabs || tabs.contains(target))) ||
        (menuBox && (target === menuBox || menuBox.contains(target))) ||
        (sciHeaderLeft &&
          (target === sciHeaderLeft || sciHeaderLeft.contains(target))) ||
        (sciList && (target === sciList || sciList.contains(target))) ||
        (setting && (target === setting || setting.contains(target))) ||
        isInFeedbackDialog ||
        isInDownloadErrorDialog ||
        (introlBtn && (target === introlBtn || introlBtn.contains(target)))
      ) {
        // console.log("在弹窗内部");
        return;
      } else {
        // console.log("弹窗外部");
        vm.closeTanChuangInfo && vm.closeTanChuangInfo();
      }
    });
  },
};

export default util;
